const FIXED_NUMBER = 2;

export function ARPPU(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = (_params.AvP - _params.COGS) * _params.Ret;
  
  return parseFloat(result.toFixed(FIXED_NUMBER), 10);
}

export function ARPU(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = ARPPU(_params) * (_params.CR1 / 100) * (_params.CR2 / 100);

  return result.toFixed(FIXED_NUMBER);
}

export function CPA(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = _params.CPC / (_params.CR1 / 100);
  
  return parseFloat(result.toFixed(FIXED_NUMBER), 10);
}

export function Leads(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = _params.UA * (_params.CR1 / 100);

  return result.toFixed(FIXED_NUMBER);
}

export function CPPU(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = _params.CPC / (_params.CR1 / 100) / (_params.CR2 / 100);

  return parseFloat(result.toFixed(FIXED_NUMBER), 10);
}

export function Buyers(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = _params.UA * (_params.CR1 / 100) * (_params.CR2 / 100);

  return result.toFixed(FIXED_NUMBER);
}

export function Budget(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = _params.UA * _params.CPC;

  return result.toFixed(FIXED_NUMBER);
}

export function Margin(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = _params.AvP - _params.COGS;

  return result.toFixed(FIXED_NUMBER);
}

export function LTV(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = (_params.AvP - _params.COGS) * _params.Ret;

  return result.toFixed(FIXED_NUMBER);
}

export function OperatingProfit(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = (_params.AvP - _params.COGS) - CPPU(_params) + (_params.AvP - _params.COGS) * (_params.Ret - 1);

  return result.toFixed(FIXED_NUMBER);
}

export function OperatingMargin(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = ((_params.AvP - _params.COGS) * _params.Ret / (_params.COGS + CPPU(_params))) * 100;

  return result.toFixed(FIXED_NUMBER);
}

export function ROI(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = ((_params.AvP - _params.COGS - CPA(_params)) * _params.Ret / (_params.COGS + CPA(_params))) * 100;

  return result.toFixed(FIXED_NUMBER);
}

export function firstSaleRev(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = (_params.AvP - _params.COGS) - CPPU(_params);

  return result.toFixed(FIXED_NUMBER);
}

export function RevenueWithoutCOGS(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = Buyers(_params) * _params.AvP * _params.Ret;

  return result.toFixed(FIXED_NUMBER);
}

export function RevenueWithCOGS(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = ARPPU(_params) * Buyers(_params);

  return result.toFixed(FIXED_NUMBER);
}

export function GrossProfit(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = ARPPU(_params) * Buyers(_params) - Budget(_params);

  return result.toFixed(FIXED_NUMBER);
}

export function MaxCPC(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = (_params.AvP - _params.COGS) * _params.Ret * (_params.CR1 / 100) * (_params.CR2 / 100);

  return result.toFixed(FIXED_NUMBER);
}

export function MaxCPA(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = (_params.AvP - _params.COGS) * _params.Ret * (_params.CR2 / 100);

  return result.toFixed(FIXED_NUMBER);
}

export function CPL(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = _params.CPC / (_params.CR1 / 100);

  return result.toFixed(FIXED_NUMBER);
}

export function profitPerPayUser(params) {
  let result = 0;
  let _params = {};

  _params = paramsToNumbers(params);
  result = -(_params.CPC / (_params.CR1 / 100) / (_params.CR2 / 100)) + (_params.AvP - _params.COGS) * _params.Ret;

  return result.toFixed(FIXED_NUMBER);
}

export function profit(params) {
  let result = 0;
  let _params = {};
  
  _params = paramsToNumbers(params);
  result = _params.UA * (_params.CR1 / 100) * (_params.CR2 / 100) * (-CPPU(_params) + ARPPU(_params));

  return result.toFixed(FIXED_NUMBER);
}

function paramsToNumbers(params) {
  const _params = Object.assign({}, params);

  for (const param in _params) {
    if (typeof _params[param] === 'string') {
      _params[param] = _params[param].replace(',', '.');
    }

    _params[param] = _params[param].length !== 0 ? parseFloat(_params[param], 10) : 0;
  }

  return _params;
}


// WEBPACK FOOTER //
// ./src/services/formulas.js